import { gql } from 'apollo-angular'

export default gql`
  mutation edit_comment_by_pk($id: Int!, $_set: comment_set_input) {
    update_comment(where: { id: { _eq: $id } }, _set: $_set) {
      affected_rows
      returning {
        id
      }
    }
  }
`
